/* global axios */
import ApiClient from './ApiClient';

class UserAgendaAPI extends ApiClient {
  constructor() {
    super('user_agenda', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.patch(this.url, data);
  }
}

export default new UserAgendaAPI();
